// extracted by mini-css-extract-plugin
export var noscroll = "layout-module--noscroll--+pnsl";
export var anchor = "layout-module--anchor--nu5Pp";
export var x = "layout-module--x--2vkfp";
export var item = "layout-module--item--b12hb";